var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2552,
    cy: 16.4033,
    r: 15.4993,
    stroke: "#EAEAEA",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28467 13.0333L14.9762 16.8855C15.4371 17.1974 15.6675 17.3534 15.9182 17.4138C16.1396 17.4672 16.3712 17.4672 16.5926 17.4138C16.8432 17.3534 17.0737 17.1974 17.5346 16.8855L23.2261 13.0333M12.6306 21.7953H19.8801C21.0513 21.7953 21.6369 21.7953 22.0843 21.5749C22.4777 21.3811 22.7977 21.0717 22.9981 20.6913C23.2261 20.2587 23.2261 19.6925 23.2261 18.5601V14.2465C23.2261 13.1141 23.2261 12.5478 22.9981 12.1153C22.7977 11.7348 22.4777 11.4255 22.0843 11.2317C21.6369 11.0113 21.0513 11.0113 19.8801 11.0113H12.6306C11.4594 11.0113 10.8738 11.0113 10.4265 11.2317C10.033 11.4255 9.71309 11.7348 9.5126 12.1153C9.28467 12.5478 9.28467 13.1141 9.28467 14.2465V18.5601C9.28467 19.6925 9.28467 20.2587 9.5126 20.6913C9.71309 21.0717 10.033 21.3811 10.4265 21.5749C10.8738 21.7953 11.4594 21.7953 12.6306 21.7953Z",
    stroke: "#484C50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.aea602d6b09f587d39f204b058a9537e.svg";
export { ForwardRef as ReactComponent };